import {Button,Table} from 'ant-design-vue'
import { createNamespacedHelpers  } from 'vuex'
// const {Header,Content,Footer} = Layout;
import {util} from '@utils'
import CommonFramework from "@/shared/components/lyCommonFramework/index";
import pageOption from '../empManage/pageOption'
import cookie from 'js-cookie'

// const data = [{
//     id: '0',
//     roleName: 'Edward King 0',
//     ct: '2019-9-17 17:46',
//     mt: '2019-9-17 17:46',
//     roleType:1
// }, {
//     id: '1',
//     roleName: 'Edward King 1',
//     ct: '2019-9-17 17:46',
//     mt: '2019-9-17 17:46',
//     roleType:1
// }]

const {mapActions,mapState } = createNamespacedHelpers('pages/empManage')
export default {
    components:{Button,Table,CommonFramework},
    mixins: [ pageOption ],
    data() {
        return {
            isChildRoute: false,
            rowKey: 'roleId',
            columns: [{
                title: '角色名称',
                dataIndex: 'roleName',
                align: 'center'
            }, {
                title: '创建时间',
                dataIndex: 'createTime',
                align: 'center'
            },
            //   {
            //     title: '修改时间',
            //     dataIndex: 'mt',
            //     align: 'center'
            // },
              {
                title: '操作',
                align: 'center',
                scopedSlots: { customRender: 'operation' },
            }]
        }
    },
    mounted(){
        // debugger
        // this.startRequest()
    },
    watch:{
        $route:{
            immediate:true,
            async handler(newVal){
                if (newVal.name === 'lyRoleAdd') {
                    this.isChildRoute = true;
                } else {
                    this.isChildRoute = false;
                    await this.startRequest()
                }
            }
        },
        // roleListCount:{
        //     immediate:true,
        //     handler(newVal){
        //         this.pageOption.total = newVal
        //     }
        // }
    },
    methods: {
        ...mapActions(['listAllRoles']),
        routeJump(type,id){
            let query = type==='roleAdd'?{}:{id}
            this.isChildRoute = true;
            // this.$router.push({path:`/my/roleManage/${type}`,query});
            this.$router.push({name:'lyRoleAdd',params:{type},query});
        },
        async startRequest(){
            const {current,pageSize} = this.pageOption;
            let aid = cookie.get('id');
            let params = {
                // pageIndex:current, //页数
                // pageSize:pageSize,
                aid,
            };
            await this.listAllRoles({params})
            this.pageOption.total = this.roleListCount
        }
    },
    computed:{
        ...mapState({
            roleListOrigin: state => state.rolesList,
            // roleListCount: state => state.roleListCount,
        }),
        roleList() { // 商户管理员（roleCode：0000）不显示，王虎与陈剑2019.12.24确认
            return (this.roleListOrigin || []).filter(v => v.roleCode !== '0000')
        }
    }
  }
